export default "__VITE_ASSET__12370334__"